import { useEffect, useState } from "react";

export default function AssetImg({ id, url, sha256 }) {
    const [alt, setAlt] = useState(`Loading image number ${id}`);
    const [src, setSrc] = useState(null);

    useEffect(() => {
        if (!id && !url) return;
        if (!url) url = `/v1/api/assets/${id}`;
        fetch(url)
            .then(res => res.json())
            .then(data => {
                if (data && sha256 && data.sha256 !== sha256) {
                    setAlt(`Image number ${id} has been corrupted`);
                } else if (data && data.alias) {
                    setAlt(data.alias);
                    setSrc(`${url}/$blob`);
                }
            })
            .catch(() => setAlt(`Failed to load image number ${id}`));
    }, [id, url, sha256]);

    if (!src) return <h1>{alt}</h1>;
    return <img src={src} alt={alt} />;
}